export default {
    API_ENDPOINT: 'https://warm-spire-44026.herokuapp.com/api',
    TOKEN_KEY: 'secret-santa-auth-token'
}